<script>
   import { onMount } from 'svelte';

   export let label;
   export let tabControl;

   let tabHeader;

   $: tabNow = tabControl.activeTab;
   function handleClick() {
      tabControl.setActiveTab(label);
   }

   $: {
      if(label && tabControl) {
         tabControl.registerTab(label, tabHeader);
      }
   }

   onMount(() => {
      return () => {
         if(label && tabControl) {
            tabControl.discardTab(label);
         }
      };
   });
</script>

<li bind:this={tabHeader} class:active={tabNow === label}>
    <span on:click={handleClick}>{label}</span>
</li>
{#if tabNow === label}
    <div class="box">
        <slot />
    </div>
{/if}

<style>
    .box {
        margin-bottom: 1em;
        padding: 40px;
        border: 1px solid #323232;
        border-radius: .5rem;

        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
        backdrop-filter: blur(1.4px) saturate(0.56) brightness(1.05);
    }

    li {
        margin-bottom: -1px;
    }

    span {
        border: 1px solid transparent;
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;

        display: block;
        padding: 0.5rem 1rem;
        cursor: pointer;
    }

    span:hover {
        border-color: #AC8B64 #AC8B64 #AC8B64;
    }

    li.active > span {
        color: white;
        background-color: #AC8B64;
        border-color: #323232 #323232 #323232;
    }
</style>